import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FirebaseAuthService } from '../../services/auth/firebase-auth.service';
import { MembershipService } from '../../services/auth/membership.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { PathConstants } from '../../constants/PathConstants';
import { GuideAnchorDirective } from '../../guides/guide-anchor.directive';
import { KioskService } from '../../services/kiosk.service';
import { KioskUnlockDialogComponent } from '../kiosk-unlock-dialog/kiosk-unlock-dialog.component';

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, GuideAnchorDirective],
})
export class SideMenuComponent {
  firebaseUser = inject(FirebaseAuthService);
  membership = inject(MembershipService);
  readonly kiosk = inject(KioskService);
  private flags = inject(FeatureFlagService);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  readonly invoicingEnabled = computed(() => this.flags.isEnabled('invoicing'));
  readonly teleconsultaEnabled = computed(
    () => this.flags.isEnabled('teleconsulta') && this.membership.canManageClinicalRecords()
  );

  public toPatientsPage() {
    this.toPage(PathConstants.PATIENTS_PATH);
  }

  public toRegisterPage() {
    this.toPage(PathConstants.PATIENT_REGISTER_PATH);
  }

  public unlock(): void {
    this.dialog
      .open(KioskUnlockDialogComponent, { width: '360px', autoFocus: 'first-tabbable' })
      .afterClosed()
      .subscribe((unlocked?: boolean) => {
        if (!unlocked) {
          return;
        }
        this.kiosk.unlock();
        void this.router.navigate([PathConstants.PATIENTS_PATH]);
      });
  }

  public toMedicinesPage() {
    this.toPage(PathConstants.MEDICATIONS_PATH);
  }

  public toAppointmentsPage() {
    this.toPage(PathConstants.APPOINTMENTS_PATH);
  }

  public toCitasPage() {
    this.toPage(PathConstants.CITAS_PATH);
  }

  public toPlantillasPage() {
    this.toPage(PathConstants.PLANTILLAS_PATH);
  }

  public toFacturacionPage() {
    this.toPage(PathConstants.FACTURACION_PATH);
  }

  public toTeleconsultaPage() {
    this.toPage(PathConstants.TELECONSULTA_PATH);
  }

  public toConsultorioPage() {
    this.toPage(PathConstants.CONSULTORIO_PATH);
  }

  public toPerfilPage() {
    this.toPage(PathConstants.PERFIL_PATH);
  }

  public toAdminPage() {
    this.toPage(PathConstants.ADMIN_PATH);
  }

  public toPage(page: string) {
    if (this.router.url == page) {
      return;
    }
    this.router.navigate([page]);
  }

  blurNav(event: Event): void {
    const target = event.currentTarget;
    if (target instanceof HTMLElement) {
      target.blur();
    }
  }
}
